(function () {
  var WISHLIST_KEY = 'fac_wishlist';
  var RECENT_KEY = 'fac_recently_viewed';
  var RECENT_LIMIT = 6;

  var ESCAPE_MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (ch) { return ESCAPE_MAP[ch]; });
  }

  function read(key) {
    try {
      var raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function write(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      /* storage unavailable, fail quietly */
    }
  }

  function itemFrom(el) {
    return {
      handle: el.getAttribute('data-product-handle'),
      title: el.getAttribute('data-product-title'),
      image: el.getAttribute('data-product-image'),
      price: el.getAttribute('data-product-price')
    };
  }

  function renderList(container, items, emptyMessage, removable) {
    if (!container) return;
    if (!items.length) {
      container.innerHTML = '<p class="saved-list__empty">' + emptyMessage + '</p>';
      return;
    }
    container.innerHTML = '<div class="product-grid">' + items.map(function (item) {
      var removeBtn = removable
        ? '<button type="button" class="product-card__remove" data-remove-saved="' + escapeHtml(item.handle) + '" aria-label="Remove from saved items">&times;</button>'
        : '';
      return '<div class="product-card" data-saved-card>' +
        removeBtn +
        '<a href="/products/' + encodeURIComponent(item.handle) + '">' +
          '<div class="product-card__media">' +
            (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="" class="product-card__img product-card__img--primary" loading="lazy">' : '') +
          '</div>' +
          '<div class="product-card__info">' +
            '<h3 class="product-card__title">' + escapeHtml(item.title) + '</h3>' +
            '<p class="product-card__price">' + escapeHtml(item.price || '') + '</p>' +
          '</div>' +
        '</a>' +
      '</div>';
    }).join('') + '</div>';

    if (removable) {
      container.querySelectorAll('[data-remove-saved]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var handle = btn.getAttribute('data-remove-saved');
          var list = read(WISHLIST_KEY).filter(function (i) { return i.handle !== handle; });
          write(WISHLIST_KEY, list);
          renderList(container, list, 'Nothing saved yet. Tap "Save for next drop" on any piece to keep track of it.', true);
          syncAllForHandle(handle);
        });
      });
    }
  }

  function syncAllForHandle(handle) {
    var saved = read(WISHLIST_KEY).some(function (i) { return i.handle === handle; });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (t) {
      if (t.getAttribute('data-product-handle') !== handle) return;
      t.classList.toggle('is-saved', saved);
      t.setAttribute('aria-pressed', String(saved));
      var lbl = t.querySelector('[data-wishlist-label]');
      if (lbl) lbl.textContent = saved ? 'Saved' : 'Save for next drop';
      if (t.hasAttribute('data-wishlist-page-toggle')) {
        var confirmLink = document.querySelector('[data-wishlist-confirm]');
        if (confirmLink) confirmLink.hidden = !saved;
      }
    });
  }

  function bindToggle(toggle) {
    var handle = toggle.getAttribute('data-product-handle');
    if (!handle) return;

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var list = read(WISHLIST_KEY);
      var index = list.findIndex(function (i) { return i.handle === handle; });
      if (index > -1) {
        list.splice(index, 1);
      } else {
        list.push(itemFrom(toggle));
        if (window.fantasyAveKlaviyoTrack) {
          window.fantasyAveKlaviyoTrack('Added to Wishlist', {
            ProductName: toggle.getAttribute('data-product-title'),
            Handle: handle,
            ImageURL: toggle.getAttribute('data-product-image'),
            URL: window.location.origin + '/products/' + handle,
            Price: toggle.getAttribute('data-product-price')
          });
        }
      }
      write(WISHLIST_KEY, list);
      syncAllForHandle(handle);
    });

    syncAllForHandle(handle);
  }

  document.addEventListener('DOMContentLoaded', function () {

    /* ---------- Wishlist toggles (product page + product cards) ---------- */
    document.querySelectorAll('[data-wishlist-toggle]').forEach(bindToggle);

    /* ---------- Track this product as recently viewed (product page only) ---------- */
    var pageToggle = document.querySelector('[data-wishlist-page-toggle]');
    var pageHandle = pageToggle ? pageToggle.getAttribute('data-product-handle') : null;
    if (pageToggle && pageHandle) {
      var recent = read(RECENT_KEY).filter(function (i) { return i.handle !== pageHandle; });
      recent.unshift(itemFrom(pageToggle));
      write(RECENT_KEY, recent.slice(0, RECENT_LIMIT));
    }

    /* ---------- Saved page ---------- */
    renderList(
      document.querySelector('[data-wishlist-list]'),
      read(WISHLIST_KEY),
      'Nothing saved yet. Tap "Save for next drop" on any piece to keep track of it.',
      true
    );

    /* ---------- Recently viewed strip ---------- */
    var recentContainer = document.querySelector('[data-recently-viewed]');
    if (recentContainer) {
      var items = read(RECENT_KEY).filter(function (i) { return i.handle !== pageHandle; });
      if (!items.length) {
        recentContainer.closest('[data-recently-viewed-section]').style.display = 'none';
      } else {
        renderList(recentContainer, items, '');
      }
    }
  });
})();
